// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manual-domain-add-container {
  max-width: 1000px;
  margin: 40px auto;
  padding: 30px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.dark .manual-domain-add-container {
  background-color: rgb(15 23 42);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.header-section {
  margin-bottom: 30px;
  text-align: center;
}

.header-section h1 {
  font-size: 32px;
  margin-bottom: 10px;
  color: #333;
  font-weight: 700;
}

.dark .header-section h1 {
  color: rgb(241 245 249);
}

.subtitle {
  font-size: 14px;
  color: #666;
  margin-top: 8px;
}

.dark .subtitle {
  color: rgb(148 163 184);
}

.manual-domain-form {
  margin-bottom: 30px;
}

.form-group {
  margin-bottom: 24px;
}

.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: #444;
  font-size: 14px;
}

.dark .form-group label {
  color: rgb(148 163 184);
}

.required {
  color: #f44336;
  font-weight: bold;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  box-sizing: border-box;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.dark .form-group input,
.dark .form-group textarea {
  background-color: rgb(15 23 42);
  border-color: rgb(51 65 85);
  color: rgb(241 245 249);
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #4CAF50;
  box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 120px;
  line-height: 1.5;
}

.help-text {
  display: block;
  margin-top: 6px;
  color: #666;
  font-size: 12px;
  font-style: italic;
}

.dark .help-text {
  color: rgb(148 163 184);
}

.button-group {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.submit-btn {
  flex: 1 1;
  padding: 14px 24px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.1s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.submit-btn:hover:not(:disabled) {
  background-color: #45a049;
  transform: translateY(-1px);
}

.submit-btn:active:not(:disabled) {
  transform: translateY(0);
}

.submit-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
  transform: none;
}

.reset-btn {
  padding: 14px 24px;
  background-color: #757575;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

.reset-btn:hover {
  background-color: #616161;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #ffffff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.progress-section {
  margin-top: 24px;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 6px;
}

.dark .progress-section {
  background-color: rgb(30 41 59);
}

.progress-section h3 {
  font-size: 18px;
  margin-bottom: 12px;
  color: #333;
}

.dark .progress-section h3 {
  color: rgb(241 245 249);
}

.progress-messages {
  max-height: 300px;
  overflow-y: auto;
  font-family: 'Courier New', monospace;
  font-size: 13px;
}

.progress-message {
  padding: 8px 12px;
  margin-bottom: 4px;
  border-radius: 4px;
  display: flex;
  gap: 10px;
}

.progress-message.info {
  background-color: #e3f2fd;
  color: #1565c0;
}

.dark .progress-message.info {
  background-color: rgb(30 58 138);
  color: rgb(147 197 253);
}

.progress-message.success {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.dark .progress-message.success {
  background-color: rgb(20 83 45);
  color: rgb(134 239 172);
}

.progress-message.error {
  background-color: #ffebee;
  color: #c62828;
}

.dark .progress-message.error {
  background-color: rgb(127 29 29);
  color: rgb(252 165 165);
}

.timestamp {
  font-weight: 600;
}

.error-message {
  padding: 20px;
  background-color: #ffebee;
  border-left: 4px solid #f44336;
  color: #c62828;
  border-radius: 6px;
  margin-top: 24px;
  display: flex;
  gap: 15px;
  align-items: flex-start;
}

.dark .error-message {
  background-color: rgb(127 29 29);
  color: rgb(252 165 165);
}

.message-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.message-content {
  flex: 1 1;
}

.message-content strong {
  display: block;
  margin-bottom: 8px;
  font-size: 16px;
}

.message-content p {
  margin: 0;
  line-height: 1.5;
}

.results-container {
  margin-top: 30px;
  padding: 24px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.dark .results-container {
  background-color: rgb(30 41 59);
}

.results-container h2 {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
  font-weight: 700;
}

.dark .results-container h2 {
  color: rgb(241 245 249);
}

.results-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.metrics-summary {
  background-color: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.dark .metrics-summary {
  background-color: rgb(15 23 42);
}

.metric-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 6px;
  border-left: 3px solid #2196F3;
}

.dark .metric-item {
  background-color: rgb(30 41 59);
}

.metric-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.metric-label {
  font-size: 14px;
  color: #666;
  flex: 1 1;
}

.dark .metric-label {
  color: rgb(148 163 184);
}

.metric-value {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}

.dark .metric-value {
  color: rgb(241 245 249);
}

.summary-card {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 16px;
  border-left: 4px solid #ddd;
}

.dark .summary-card {
  background-color: rgb(15 23 42);
  border-left-color: rgb(51 65 85);
}

.summary-card.total {
  border-left-color: #2196F3;
}

.summary-card.success {
  border-left-color: #4CAF50;
}

.summary-card.failed {
  border-left-color: #f44336;
}

.card-icon {
  font-size: 32px;
  flex-shrink: 0;
}

.card-content {
  flex: 1 1;
}

.card-value {
  font-size: 28px;
  font-weight: 700;
  color: #333;
  line-height: 1;
}

.dark .card-value {
  color: rgb(241 245 249);
}

.card-label {
  font-size: 13px;
  color: #666;
  margin-top: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.dark .card-label {
  color: rgb(148 163 184);
}

.domain-results {
  margin-top: 24px;
}

.domain-results h3 {
  font-size: 20px;
  margin-bottom: 16px;
  color: #444;
  font-weight: 600;
}

.dark .domain-results h3 {
  color: rgb(203 213 225);
}

.domain-result {
  background-color: #ffffff;
  padding: 20px;
  margin-bottom: 16px;
  border-radius: 6px;
  border-left: 4px solid #ddd;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.dark .domain-result {
  background-color: rgb(15 23 42);
  border-left-color: rgb(51 65 85);
}

.domain-result.success {
  border-left-color: #4CAF50;
}

.domain-result.failure {
  border-left-color: #f44336;
  background-color: #fff5f5;
}

.dark .domain-result.failure {
  background-color: rgb(127 29 29);
}

.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eee;
}

.dark .result-header {
  border-bottom-color: rgb(51 65 85);
}

.result-header h4 {
  margin: 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.dark .result-header h4 {
  color: rgb(241 245 249);
}

.status-badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge.success {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.dark .status-badge.success {
  background-color: rgb(20 83 45);
  color: rgb(134 239 172);
}

.status-badge.failure {
  background-color: #ffebee;
  color: #c62828;
}

.dark .status-badge.failure {
  background-color: rgb(127 29 29);
  color: rgb(252 165 165);
}

.result-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.result-stat,
.result-message {
  font-size: 14px;
  color: #555;
}

.dark .result-stat,
.dark .result-message {
  color: rgb(203 213 225);
}

.result-stat strong,
.result-message strong {
  color: #333;
  margin-right: 6px;
}

.dark .result-stat strong,
.dark .result-message strong {
  color: rgb(241 245 249);
}

.result-note {
  padding: 12px;
  border-radius: 4px;
  font-size: 13px;
  background-color: #fff3e0;
  color: #e65100;
  border-left: 3px solid #ff9800;
}

.result-note.fallback {
  background-color: #e3f2fd;
  color: #0d47a1;
  border-left-color: #2196F3;
}

.logs {
  margin-top: 12px;
  padding: 14px;
  background-color: #f5f5f5;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.dark .logs {
  background-color: rgb(30 41 59);
  border-color: rgb(51 65 85);
}

.logs strong {
  display: block;
  margin-bottom: 10px;
  color: #666;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.dark .logs strong {
  color: rgb(148 163 184);
}

.logs ul {
  margin: 0;
  padding-left: 20px;
}

.logs li {
  margin: 6px 0;
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  font-family: 'Courier New', monospace;
}

.dark .logs li {
  color: rgb(148 163 184);
}

.error-text {
  color: #c62828;
  font-weight: 500;
  padding: 12px;
  background-color: #ffebee;
  border-radius: 4px;
  border-left: 3px solid #f44336;
}

.dark .error-text {
  background-color: rgb(127 29 29);
  color: rgb(252 165 165);
}

/* Responsive Design */
@media (max-width: 768px) {
  .manual-domain-add-container {
    margin: 20px;
    padding: 20px;
  }

  .header-section h1 {
    font-size: 24px;
  }

  .results-summary {
    grid-template-columns: 1fr;
  }

  .button-group {
    flex-direction: column;
  }

  .result-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/manualDomainAdd/ManualDomainAdd.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;;EAEE,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAO;AACT;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;AACF","sourcesContent":[".manual-domain-add-container {\n  max-width: 1000px;\n  margin: 40px auto;\n  padding: 30px;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.dark .manual-domain-add-container {\n  background-color: rgb(15 23 42);\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n}\n\n.header-section {\n  margin-bottom: 30px;\n  text-align: center;\n}\n\n.header-section h1 {\n  font-size: 32px;\n  margin-bottom: 10px;\n  color: #333;\n  font-weight: 700;\n}\n\n.dark .header-section h1 {\n  color: rgb(241 245 249);\n}\n\n.subtitle {\n  font-size: 14px;\n  color: #666;\n  margin-top: 8px;\n}\n\n.dark .subtitle {\n  color: rgb(148 163 184);\n}\n\n.manual-domain-form {\n  margin-bottom: 30px;\n}\n\n.form-group {\n  margin-bottom: 24px;\n}\n\n.form-group label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #444;\n  font-size: 14px;\n}\n\n.dark .form-group label {\n  color: rgb(148 163 184);\n}\n\n.required {\n  color: #f44336;\n  font-weight: bold;\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color 0.3s, box-shadow 0.3s;\n}\n\n.dark .form-group input,\n.dark .form-group textarea {\n  background-color: rgb(15 23 42);\n  border-color: rgb(51 65 85);\n  color: rgb(241 245 249);\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #4CAF50;\n  box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.1);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 120px;\n  line-height: 1.5;\n}\n\n.help-text {\n  display: block;\n  margin-top: 6px;\n  color: #666;\n  font-size: 12px;\n  font-style: italic;\n}\n\n.dark .help-text {\n  color: rgb(148 163 184);\n}\n\n.button-group {\n  display: flex;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.submit-btn {\n  flex: 1;\n  padding: 14px 24px;\n  background-color: #4CAF50;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s, transform 0.1s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.submit-btn:hover:not(:disabled) {\n  background-color: #45a049;\n  transform: translateY(-1px);\n}\n\n.submit-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.submit-btn:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.reset-btn {\n  padding: 14px 24px;\n  background-color: #757575;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.reset-btn:hover {\n  background-color: #616161;\n}\n\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #ffffff;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.progress-section {\n  margin-top: 24px;\n  padding: 20px;\n  background-color: #f5f5f5;\n  border-radius: 6px;\n}\n\n.dark .progress-section {\n  background-color: rgb(30 41 59);\n}\n\n.progress-section h3 {\n  font-size: 18px;\n  margin-bottom: 12px;\n  color: #333;\n}\n\n.dark .progress-section h3 {\n  color: rgb(241 245 249);\n}\n\n.progress-messages {\n  max-height: 300px;\n  overflow-y: auto;\n  font-family: 'Courier New', monospace;\n  font-size: 13px;\n}\n\n.progress-message {\n  padding: 8px 12px;\n  margin-bottom: 4px;\n  border-radius: 4px;\n  display: flex;\n  gap: 10px;\n}\n\n.progress-message.info {\n  background-color: #e3f2fd;\n  color: #1565c0;\n}\n\n.dark .progress-message.info {\n  background-color: rgb(30 58 138);\n  color: rgb(147 197 253);\n}\n\n.progress-message.success {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n}\n\n.dark .progress-message.success {\n  background-color: rgb(20 83 45);\n  color: rgb(134 239 172);\n}\n\n.progress-message.error {\n  background-color: #ffebee;\n  color: #c62828;\n}\n\n.dark .progress-message.error {\n  background-color: rgb(127 29 29);\n  color: rgb(252 165 165);\n}\n\n.timestamp {\n  font-weight: 600;\n}\n\n.error-message {\n  padding: 20px;\n  background-color: #ffebee;\n  border-left: 4px solid #f44336;\n  color: #c62828;\n  border-radius: 6px;\n  margin-top: 24px;\n  display: flex;\n  gap: 15px;\n  align-items: flex-start;\n}\n\n.dark .error-message {\n  background-color: rgb(127 29 29);\n  color: rgb(252 165 165);\n}\n\n.message-icon {\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.message-content {\n  flex: 1;\n}\n\n.message-content strong {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 16px;\n}\n\n.message-content p {\n  margin: 0;\n  line-height: 1.5;\n}\n\n.results-container {\n  margin-top: 30px;\n  padding: 24px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n}\n\n.dark .results-container {\n  background-color: rgb(30 41 59);\n}\n\n.results-container h2 {\n  font-size: 24px;\n  margin-bottom: 20px;\n  color: #333;\n  font-weight: 700;\n}\n\n.dark .results-container h2 {\n  color: rgb(241 245 249);\n}\n\n.results-summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.metrics-summary {\n  background-color: #f5f5f5;\n  padding: 20px;\n  border-radius: 8px;\n  margin-bottom: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.dark .metrics-summary {\n  background-color: rgb(15 23 42);\n}\n\n.metric-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  background-color: #ffffff;\n  border-radius: 6px;\n  border-left: 3px solid #2196F3;\n}\n\n.dark .metric-item {\n  background-color: rgb(30 41 59);\n}\n\n.metric-icon {\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.metric-label {\n  font-size: 14px;\n  color: #666;\n  flex: 1;\n}\n\n.dark .metric-label {\n  color: rgb(148 163 184);\n}\n\n.metric-value {\n  font-size: 18px;\n  font-weight: 700;\n  color: #333;\n}\n\n.dark .metric-value {\n  color: rgb(241 245 249);\n}\n\n.summary-card {\n  background-color: #ffffff;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  border-left: 4px solid #ddd;\n}\n\n.dark .summary-card {\n  background-color: rgb(15 23 42);\n  border-left-color: rgb(51 65 85);\n}\n\n.summary-card.total {\n  border-left-color: #2196F3;\n}\n\n.summary-card.success {\n  border-left-color: #4CAF50;\n}\n\n.summary-card.failed {\n  border-left-color: #f44336;\n}\n\n.card-icon {\n  font-size: 32px;\n  flex-shrink: 0;\n}\n\n.card-content {\n  flex: 1;\n}\n\n.card-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: #333;\n  line-height: 1;\n}\n\n.dark .card-value {\n  color: rgb(241 245 249);\n}\n\n.card-label {\n  font-size: 13px;\n  color: #666;\n  margin-top: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.dark .card-label {\n  color: rgb(148 163 184);\n}\n\n.domain-results {\n  margin-top: 24px;\n}\n\n.domain-results h3 {\n  font-size: 20px;\n  margin-bottom: 16px;\n  color: #444;\n  font-weight: 600;\n}\n\n.dark .domain-results h3 {\n  color: rgb(203 213 225);\n}\n\n.domain-result {\n  background-color: #ffffff;\n  padding: 20px;\n  margin-bottom: 16px;\n  border-radius: 6px;\n  border-left: 4px solid #ddd;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.dark .domain-result {\n  background-color: rgb(15 23 42);\n  border-left-color: rgb(51 65 85);\n}\n\n.domain-result.success {\n  border-left-color: #4CAF50;\n}\n\n.domain-result.failure {\n  border-left-color: #f44336;\n  background-color: #fff5f5;\n}\n\n.dark .domain-result.failure {\n  background-color: rgb(127 29 29);\n}\n\n.result-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #eee;\n}\n\n.dark .result-header {\n  border-bottom-color: rgb(51 65 85);\n}\n\n.result-header h4 {\n  margin: 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.dark .result-header h4 {\n  color: rgb(241 245 249);\n}\n\n.status-badge {\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-badge.success {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n}\n\n.dark .status-badge.success {\n  background-color: rgb(20 83 45);\n  color: rgb(134 239 172);\n}\n\n.status-badge.failure {\n  background-color: #ffebee;\n  color: #c62828;\n}\n\n.dark .status-badge.failure {\n  background-color: rgb(127 29 29);\n  color: rgb(252 165 165);\n}\n\n.result-body {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.result-stat,\n.result-message {\n  font-size: 14px;\n  color: #555;\n}\n\n.dark .result-stat,\n.dark .result-message {\n  color: rgb(203 213 225);\n}\n\n.result-stat strong,\n.result-message strong {\n  color: #333;\n  margin-right: 6px;\n}\n\n.dark .result-stat strong,\n.dark .result-message strong {\n  color: rgb(241 245 249);\n}\n\n.result-note {\n  padding: 12px;\n  border-radius: 4px;\n  font-size: 13px;\n  background-color: #fff3e0;\n  color: #e65100;\n  border-left: 3px solid #ff9800;\n}\n\n.result-note.fallback {\n  background-color: #e3f2fd;\n  color: #0d47a1;\n  border-left-color: #2196F3;\n}\n\n.logs {\n  margin-top: 12px;\n  padding: 14px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  border: 1px solid #e0e0e0;\n}\n\n.dark .logs {\n  background-color: rgb(30 41 59);\n  border-color: rgb(51 65 85);\n}\n\n.logs strong {\n  display: block;\n  margin-bottom: 10px;\n  color: #666;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.dark .logs strong {\n  color: rgb(148 163 184);\n}\n\n.logs ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.logs li {\n  margin: 6px 0;\n  font-size: 13px;\n  color: #666;\n  line-height: 1.6;\n  font-family: 'Courier New', monospace;\n}\n\n.dark .logs li {\n  color: rgb(148 163 184);\n}\n\n.error-text {\n  color: #c62828;\n  font-weight: 500;\n  padding: 12px;\n  background-color: #ffebee;\n  border-radius: 4px;\n  border-left: 3px solid #f44336;\n}\n\n.dark .error-text {\n  background-color: rgb(127 29 29);\n  color: rgb(252 165 165);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .manual-domain-add-container {\n    margin: 20px;\n    padding: 20px;\n  }\n\n  .header-section h1 {\n    font-size: 24px;\n  }\n\n  .results-summary {\n    grid-template-columns: 1fr;\n  }\n\n  .button-group {\n    flex-direction: column;\n  }\n\n  .result-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
